import { TextField } from '@mui/material';
import { useIsSupplierPortalProductEditorFieldDisabled } from 'hooks/useUserState_utils';

import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const TaglineField: React.FC = () => {
  const { t } = useTranslation();
  const { register } = useFormContext();
  const disabled = useIsSupplierPortalProductEditorFieldDisabled();

  return (
    <TextField
      label={t('forms.product.tagline.label')}
      fullWidth
      margin="normal"
      {...register('private_attributes.data.tagline')}
      disabled={disabled}
    />
  );
};
